import { withTranslation } from 'react-i18next';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Parent from '../../../common/parent';
import Search from '../../../images/search.svg';
import Print from '../../../images/print.svg';
import Excel from '../../../images/excel.png';
import Cheque from '../../../images/cheque.png';
import Pdf from '../../../images/pdf.svg';
import {DropDown} from '../../../common/simple/dropDown';
import TableToExcel from '../../../common/utils/tableToExcel';
import { GAEvent } from '../../../common/google_analytics/google_analytics';
import { constants } from '../../../common/constants/constants';
import PdfWrapper from '../../../common/export_documents/PdfWrapper';
import {createPdfFromHtml} from '../../../common/shared/statelessMethods';

class ReportsToolBar extends Parent {
    constructor(props) {
        super(props);
        this.state = {
            showNewFeatureTooltip: true,
            isPdfAvailable: false
        };
    }

    componentDidMount() {
         this.showNewFeature();
    }

    showNewFeature = () => {
        setTimeout(() => { this.setState({showNewFeatureTooltip: false}) }, 3000);
    }

    onPrintClicked = evt => {
        evt.preventDefault();
        this.reportToAnalytics('print');
        window.print();
    }
    onSaveClick = async evt => {
        evt.preventDefault();
        this.setState({
            isPdfAvailable: true
        });
    }
    onSavePdf = async container => {
        this.startLoader();
        const reportFileName = document.querySelector('table').getAttribute('data-excel-title');
        await createPdfFromHtml(container, reportFileName);
        this.setState({
            isPdfAvailable: false
        });
        this.endLoader();
        this.reportToAnalytics('download');
    }

    onChequeDepositPrintClick = evt => {
        evt.preventDefault();
        this.reportToAnalytics('printChequeDeposit');
        window.location.href = `/${constants.pages.monthlyChequesUrl}/${this.props.buildingID}/${this.props.month}/${this.props.year}`
    }

    onExcelClicked = evt => {
        evt.preventDefault();
        this.reportToAnalytics('excel');
        // ToDo save title to store when access page
        const reportFileName = document.querySelector('table').getAttribute('data-excel-title');
        TableToExcel.exportToExcel2(reportFileName);
    }

    reportToAnalytics = (typeOfButton) => {
        // ToDo save page name to store and get it from there
        const tableName = document.querySelector('.js-table-title').getAttribute('tablename');
        GAEvent(constants.GoogleAnalytics.Events.clicks, typeOfButton, 1, tableName);
    }

    renderDropDown = () => {
        if (!this.props.hideDropDown) {
            return (
                <DropDown
                    id="select-year"
                    onSelectChange={this.props.onChange}
                    callingObj={this}
                    options={this.props.options || []}
                    value={this.props.defaultValue}
                />
            )
        }
    }

    onTooltipToggle = (evt) => {
        this.setState({
            showNewFeatureTooltip: evt
        });
    }

    renderPrintChequeDepositTable = () => {
        const { t, showChequeDeposit } = this.props;
        // only valid for monthly table
        // https://bllink.monday.com/boards/1244157150/pulses/1244212206
        if (showChequeDeposit) {
            return (
                <OverlayTrigger
                    show={this.state.showNewFeatureTooltip}
                    placement="top"
                    overlay={props => (
                        <Tooltip {...props}>
                            {t('reports.cheque_deposit_tooltip')}
                        </Tooltip>
                    )}
                    onToggle={this.onTooltipToggle}
                >
                    <a
                        href="/"
                        className="pdff"
                        onClick={this.onChequeDepositPrintClick}
                    >
                        <img className="managerIcon" src={Cheque} alt="print-cheque-deposit"/>
                    </a>
                </OverlayTrigger>
            );
        }

    }

    render() {
        const { t } = this.props;

        return (
            <section>
                <div className="d-flex justify-content-between align-items-center cashflow_n">
                    <div className="d-flex justify-content-between">
                        {/* https://app.asana.com/0/1196545425570329/1199562728976556 Monthly + Apt report: search icon */}
                        <div className="srch">
                            <input type="search-alt-to-avoid-x" name="search" id="quick-search" />
                            <a href="/" className="srch-btn non-clickable-cursor">
                                <img src={Search} alt={t('search.search')} />
                            </a>
                        </div>
                        {this.renderDropDown(this)}
                    </div>
                    {
                        !this.props.isTableEmpty && (
                            <div className="cash_ul">
                                <OverlayTrigger
                                    placement="top"
                                    overlay={props => (
                                        <Tooltip {...props}>
                                            {t('reports.print_tooltip')}
                                        </Tooltip>
                                    )}
                                >
                                    <a
                                        href="/"
                                        className="pdff"
                                        onClick={this.onPrintClicked}
                                    >
                                        <img className="managerIcon" src={Print} alt="print"/>
                                    </a>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement="top"
                                    overlay={props => (
                                        <Tooltip {...props}>
                                            {t('reports.excel_tooltip')}
                                        </Tooltip>
                                    )}
                                >
                                    <a
                                        href="/"
                                        className="pdff"
                                        onClick={this.onExcelClicked}
                                    >
                                        <img className="managerIcon" src={Excel} alt="excel" />
                                    </a>
                                </OverlayTrigger>

                                <OverlayTrigger
                                    placement="top"
                                    overlay={props => (
                                        <Tooltip {...props}>
                                            {t('reports.download_tooltip')}
                                        </Tooltip>
                                    )}
                                >
                                    <a
                                        href="/"
                                        className="pdff"
                                        onClick={this.onSaveClick}
                                    >
                                        <img className="managerIcon" src={Pdf} alt="download" />
                                    </a>
                                </OverlayTrigger>
                                {this.renderPrintChequeDepositTable(this)}
                            </div>
                        )
                    }
                </div>
                {
                    this.state.isPdfAvailable && (
                        <OverlayTrigger
                            placement="top"
                            overlay={props => (
                                <Tooltip {...props}>
                                    {t('reports.download_tooltip')}
                                </Tooltip>
                            )}
                        >
                            <PdfWrapper
                                component={this.props.pdfContainer.current}
                                onSavePdf={this.onSavePdf}
                            />
                        </OverlayTrigger>                    
                    )
                }
            </section>
        );
    }
}


export default withTranslation()(ReportsToolBar);
